import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-auto col-lg-8" };
const _hoisted_4 = { class: "col-auto col-lg-4" };
const _hoisted_5 = { class: "modal-footer" };
const _hoisted_6 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode($setup["BModal"], {
            ref: "editHospital",
            "no-footer": "",
            centered: "",
            size: "xl",
            title: $setup.currentUserStore.isRoot ? _ctx.$t('JTADM_HOSPITALS_EDIT_HOSPITAL') : _ctx.$t('JTADM_HOSPITALS_EDIT_HOSPITAL_REQUEST')
        }, {
            default: _withCtx(() => [
                ($props.access && $setup.hospital)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode($setup["BContainer"], { fluid: "" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createVNode($setup["HospitalSuggestion"], {
                                            "model-value": $setup.hospital,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.hospital) = $event)),
                                            "edit-mode": "",
                                            "onUpdate:isValid": _cache[1] || (_cache[1] = ($event) => ($setup.isValid = $event))
                                        }, null, 8, ["model-value"])
                                    ]),
                                    _createElementVNode("div", _hoisted_4, [
                                        _createVNode($setup["CertificationSelector"], {
                                            "model-value": $setup.certificationIds,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($setup.certificationIds) = $event))
                                        }, null, 8, ["model-value"])
                                    ])
                                ])
                            ]),
                            _: 1
                        })
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("footer", _hoisted_5, [
                    _createElementVNode("button", {
                        class: "btn btn-success",
                        type: "submit",
                        disabled: !$setup.isValid,
                        onClick: _withModifiers($setup.mutateHospital, ["prevent"])
                    }, _toDisplayString(_ctx.$t($setup.currentUserStore.isRoot ? 'JTADM_UPDATE' : 'JTADM_HOSPITALS_REQUEST')), 9, _hoisted_6),
                    _createElementVNode("button", {
                        class: "btn btn-danger",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => ($setup.editHospital?.hide()), ["prevent"]))
                    }, _toDisplayString(_ctx.$t('JTADM_CANCEL')), 1)
                ])
            ]),
            _: 1
        }, 8, ["title"])
    ]));
}
